import { parsePublicationSettings } from "../jsonText.js";

export function getFlutterPresentation(settings, templateId = "") {
  const config = parsePublicationSettings(settings)?.general?.flutter || {};
  const classic = templateId.startsWith("classic-newspaper");
  return {
    title: typeof config.title === "string" && config.title.trim() ? config.title.trim() : classic ? "Roundup" : "Flutter",
    explanation: typeof config.explanation === "string" && config.explanation.trim() ? config.explanation.trim()
      : classic ? "Roundup features top stories from other publications to show what is trending in different categories across the country and beyond. The stories are not part of The Johannesburg Times publication."
        : "Recent headlines from participating independent publications across the SURGEDOME network."
  };
}

export function validateFlutterPresentation(title, explanation) {
  if (typeof title !== "string" || typeof explanation !== "string") throw new Error("Enter a title and explanation as plain text.");
  if (title.trim().length > 80 || explanation.trim().length > 2000) throw new Error("Use up to 80 characters for the title and 2,000 for the explanation.");
  return { title: title.trim(), explanation: explanation.trim() };
}
